import styled from 'styled-components';

export const DetailsTabs= styled.div
.attrs(() => ({
  className: 'mt-25',
}))`
    min-width: 100px ;
    min-height: 21px;
    border-radius: 5px22;
    background: var(--background-grey, #F8F8F8) !important;
    color:#A0A0A0;
    margin:8px;
    padding:8px 16px;
    text-align:center;
    :hover{
    cursor: pointer;
    }
    .active{
        background: var(--Indigo-background, #F6F5FD) !important;
        color:#4F46E5;
    }
    
   
`;

export const DetailsTabsT= styled.div
.attrs(() => ({
  className: 'mt-25',
}))`
    min-width: 100px;
    min-height: 21px;
    border-radius: 5px;
    background: var(--background-grey, #F8F8F8) !important;
    color:#A0A0A0;
    margin-right:8px;
    padding:8px 16px;
    text-align:center;
    :hover{
      cursor: pointer;
    }
    
    .active{
      background: var(--Indigo-background, #F6F5FD) !important;
      color:#4F46E5;
    }
    
   
`;


export const FlexyRow= styled.div
.attrs(() => ({
  className: '',
}))`
    display: flex;  
    flex-wrap: wrap;
`;




export const DuesTabs= styled.div
.attrs(() => ({
  className: 'mt-25',
}))`
    min-width: 260px ;
    min-height: 21px;
    border-radius: 5px22;
    border: 1px solid var(--Indigo-bright, #CFCDFF) !important;
    border-radius: 10px;
    color:#A0A0A0;
    margin:8px;
    padding:8px 16px;
    :hover{
    cursor: pointer;
    }
    h5{
      color: #71717A;
      font-family: Plus Jakarta Sans;
      font-size: 13px !important;
      font-style: normal;
      font-weight: 500;
      text-transform: uppercase;
    }
    .value{ 
      font-family: 'Plus Jakarta Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 21px;
      color: #18181B;
    }
    h6{
        font-family: 'Plus Jakarta Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        // color: #22C55E;
    }
    // @media only screen and (max-width: 600px) {
    @media only screen and (max-width: 992px) {
      // styles for medium screens and down
      width: 100% !important;
      margin:16px;
      // background: red;
    }
    
   
`;